import { render, staticRenderFns } from "./SituationCapsocView.vue?vue&type=template&id=afd86826"
import script from "./SituationCapsocView.vue?vue&type=script&lang=js"
export * from "./SituationCapsocView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports